import { MenuContentCmp as MenuContent } from '../../components/MenuCmp';
import UIControls from '../../components/UIControlsCmp';
import Urls from '../../constants/urls';
import overview from "./imgs/FloorPlanMap.png";
import { ImageMap } from '@qiuz/react-image-map';
import { useHistory } from "react-router-dom";
import spot from "../../icons/spot.png"

const STLBMenu = () => {
  const history = useHistory()
  const mapArea = [
    {
      url: Urls.stlBlues.view1.path,
      width: '5%',
      height: '5%',
      left: '24%',
      top: '47%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view3.path,
      width: '5%',
      height: '5%',
      left: '57%',
      top: '47%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view4.path,
      width: '5%',
      height: '5%',
      left: '75%',
      top: '47%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view5.path,
      width: '5%',
      height: '5%',
      left: '62.3%',
      top: '19%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view6.path,
      width: '5%',
      height: '5%',
      left: '47.5%',
      top: '19%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view7.path,
      width: '5%',
      height: '5%',
      left: '47.5%',
      top: '79%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view8.path,
      width: '5%',
      height: '5%',
      left: '68.3%',
      top: '79%',
      render: () => (
        <span className='overview-map-button' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view10.path,
      width: '5%',
      height: '5%',
      left: '40%',
      top: '79%',
      render: () => (
        <span className='overview-map-button mobile-hidden' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view11.path,
      width: '5%',
      height: '5%',
      left: '39.5%',
      top: '19%',
      render: () => (
        <span className='overview-map-button mobile-hidden' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view12.path,
      width: '5%',
      height: '5%',
      left: '70%',
      top: '19%',
      render: () => (
        <span className='overview-map-button mobile-hidden' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view13.path,
      width: '5%',
      height: '5%',
      left: '82%',
      top: '53%',
      render: () => (
        <span className='overview-map-button mobile-hidden' >
          <img src={spot} />
        </span>
      ),
    },
    {
      url: Urls.stlBlues.view14.path,
      width: '5%',
      height: '5%',
      left: '78%',
      top: '60%',
      render: () => (
        <span className='overview-map-button mobile-hidden' >
          <img src={spot} />
        </span>
      ),
    },
  ];

  const onMapClick = (area) => {
    console.log(area);
    history.push(area.url)
  }
  return (
    <>
      <MenuContent>
        <h1>Where do you want to go?</h1>
      <ImageMap
        className="usage-map shrink"
        src={overview}
        map={mapArea}
        onMapClick={onMapClick}
      />
      </MenuContent> 
      <UIControls
        cart
        homeUrl={Urls.stlBlues.view3.path}
      />
    </>
  );
}

export default STLBMenu;